// extracted by mini-css-extract-plugin
module.exports = {"footer":"DashboardCardFooter_footer__3AfdY","skeleton":"DashboardCardFooter_skeleton__V-fBs"};